document.addEventListener('DOMContentLoaded', function () {
      const quizData = {
        part1: [
         {
            question: '1. When you feel anxious, overwhelmed, or stressed, what do you typically do FIRST?',
            options: [
              { text: "Push through and work harder—staying busy keeps the feelings at bay", points: 0 },
              { text: 'Research solutions, read articles, listen to podcasts about how to fix it', points: 0 },
              { text: 'Analyze what’s wrong and make a mental list of what needs to change', points: 0 },
              { text: 'Distract yourself (scroll social media, pour wine, binge Netflix)', points: 0 },
              { text: 'Power through and ignore it—"I don’t have time for feelings', points: 0 },
              { text: 'Try to control everything around me to feel safer', points: 0 },
            ],
          },
          {
            question: '2. Complete this sentence: I’ll finally be able to truly rest when...',
            type: "text"
          },
          {
            question: '3. How many self-help books, courses, therapy modalities, or transformation programs have you started in the past 3 years?',
            options: [
              { text: '1-2 (I’m selective and complete what I start)', points: 0 },
              { text: '3-5 (I’ve tried a few different approaches)', points: 1 },
              { text: '6-10 (I’m actively seeking solutions)', points: 2 },
              { text: '11-20 (I’ve invested significantly in my growth)', points: 3 },
              { text: ' More than 20, or honestly I’ve lost count', points: 4 },
              { text: 'I always finish what I start and don’t need anything else', points: 0 },
            ],
          },
          {
            question: '4. Of those programs/books/modalities, how many created lasting change in your daily life?',
            options: [
              { text: 'Most of them—I integrate what I learn', points: 0 },
              { text: 'About half—some stuck, some didn’t', points: 1 },
              { text: 'A few—I got insights but couldn’t sustain the practices', points: 2 },
              { text: 'Maybe one or two—I understand things intellectually but can’t embody them', points: 3 },
              { text: 'Honestly? None. I know MORE but I don’t feel different', points: 4 },
            ],
          },
          {
            question: '5. What’s your BIGGEST fear about doing deep transformation work?',
            options: [
              { text: 'It won’t work for me—I’m too broken/different/far gone', points: 3 },
              { text: 'I’ll lose my drive, ambition, or competitive edge', points: 3 },
              { text: 'I’ll waste time and money on something that doesn’t deliver', points: 2 },
              { text: ' People will think I’m weak or falling apart ', points: 2 },
              { text: ' I’ll have to feel emotions I’ve been successfully avoiding', points: 4 },
              { text: ' I’ll discover there’s something fundamentally wrong with me', points: 3 },
               { text: 'I don’t have fears about this—I’m ready', points: 0 },
            ],
          },
        ],
        part2: [
          {
            question: '1. When you commit to something for YOURSELF (not work, not family—just you), what most often gets in the way?',
            type: "text"
          },
          {
            question: '2. On a scale of 1-10, how good are you at following through on practices that don’t have external deadlines or accountability?',
            options: [
               { text: '1-2: I rarely follow through without external pressure', points: 4 },
              { text: '3-4: I struggle with consistency', points: 3 },
              { text: '5-6: It depends on how motivated I feel', points: 2 },
              { text: '7-8: I’m pretty consistent when I see value', points: 1 },
              { text: '9-10: I’m extremely disciplined and self-directed', points: 0 },
            ],
          },
          {
            question: '3. What story do you tell yourself when you skip self-care practices or "homework" from programs you’ve invested in?',
            options: [
              { text: 'I’m too busy right now—I’ll do it when things calm down', points: 2 },
              { text: 'I’ll do it tomorrow/this weekend/when I have more time', points: 2 },
              { text: 'This practice feels too simple—it can’t possibly help my complex situation', points: 3 },
              { text: 'I don’t need this—I should be able to handle it myself', points: 3 },
              { text: 'Everyone else needs me more than I need this', points: 2 },
              { text: 'This isn’t working anyway, so why bother?', points: 4 },
              { text: 'I don’t skip—I’m committed', points: 0 },
            ],
          },
          {
            question: '4.How do you feel in your body right now, as you’re taking this quiz?',
            options: [
              { text: 'Tense, tight (jaw clenched, shoulders raised, chest constricted)', points: 3 },
              { text: 'Numb, disconnected—I’m not really sure what I feel', points: 4 },
              { text: 'Tired, heavy, depleted', points: 3 },
              { text: 'Anxious, restless, wanting to rush through this', points: 2 },
              { text: 'Curious, open, present', points: 0 },
              { text: 'Skeptical, guarded, analyzing', points: 2 },
            ],
          },
          {
            question: '5. If your MIND tries to talk you out of this program halfway through, what will it say?',
            type: "text"
          },
        ],
        part3: [
          {
            question: '1. When you have an important decision to make, what’s your primary process',
            options: [
              { text: 'Make pros/cons lists, research exhaustively, consult others', points: 2 },
              { text: 'Think it through logically until I have the "right" answer', points: 2 },
              { text: 'Analyze until I’m paralyzed, then eventually make a rushed decision', points: 3 },
              { text: 'I trust my gut feeling, but then second-guess it constantly', points: 3 },
              { text: 'I feel it in my body first, then my mind catches up', points: 0 },
              { text: 'I ignore my intuition and do what’s "smart" or expected', points: 3 },
            ],
          },
          {
            question: '2. Complete this sentence: "My body is trying to tell me..."',
            type: "text"
          },
          {
            question: '3. How often do you experience physical symptoms of stress? (tension headaches, digestive issues, insomnia, jaw clenching, back pain, etc.)',
            options: [
              { text: 'Daily or almost daily', points: 4 },
              { text: 'Multiple times per week', points: 3 },
              { text: 'Once a week or a few times a month', points: 2 },
              { text: 'Rarely—maybe once a month', points: 1 },
              { text: 'Almost never', points: 0 },
            ],
          },
          {
            question: '4. When was the last time you had 30 minutes of completely unstructured time—no phone, no task, no agenda—just being?',
            options: [
              { text: 'I cant’t remember', points: 4 },
              { text: 'Months ago', points: 3 },
              { text: 'A few weeks ago', points: 2 },
              { text: 'Within the past week ', points: 1 },
              { text: 'I do this regularly', points: 0 },
              { text: 'That sounds terrifying/pointless', points: 3 },
            ],
          },
          {
            question: '5. What part of you KNOWS you need this transformation, even if another part resists?',
            type: "text"
          },
        ],

        part4: [
          {
            question: '1. Why NOW? What’s happened that makes this the right time?',
            type: "text"
          },
          {
            question: '2. Are you willing to trust your BODY’S wisdom even when your MIND says "this isn’vt working" or "this is too simple"?',
            options: [
              { text: 'Yes—I’m ready to try a completely different approach', points: 0 },
              { text: 'I’m not sure, but I’m willing to stay curious and see what happens', points: 1 },
              { text: 'Only if I can see logical proof or scientific backing', points: 2 },
              { text: 'No, I need to understand and control the process', points: 3 },
            ],
          },
          {
            question: '3. If you could wave a magic wand, what would be different 12 weeks from now?',
            type: "text"
          },
          {
            question: '4. On a scale of 1-10, how ready are you to do uncomfortable things (feel difficult emotions, challenge old patterns, practice daily even when you don’t "feel like it")?',
            options: [
              { text: '1-3: I want change but I’m scared of discomfort', points: 3 },
              { text: '4-6: I’m willing but uncertain', points: 2 },
              { text: '7-8: I’m ready—I know discomfort is part of growth', points: 1 },
              { text: '9-10: I’m ALL IN—I’ve tried comfortable and it doesn’t work', points: 0 },
              
            ],
          },
          {
            question: '5. What would have to be true for you to consider this program a success?',
            type: "text"
          },
        ],
      };

      let currentPart = 1;
      let currentQuestion = 0;
      let selectedAnswers = [];
      let partScores = {};

      const questionContainer = document.getElementById('questionContainer');
      const questionList = document.getElementById('questionList');
      const nextBtn = document.getElementById('nextQuestion');
      const prevBtn = document.getElementById('prevQuestion');
      const scoreModal = document.getElementById('scoreModal');
      const finalScore = document.getElementById('finalScore');
      const scoreMessage = document.getElementById('scoreMessage');
      const scoreTitle = document.getElementById('scoreTitle');
      const closeScoreModal = document.getElementById('closeScoreModal');
      const continueQuizBtn = document.getElementById('continueQuizBtn');
      // Assessment Popup
const assessmentPopup = document.getElementById("assessmentPopup");
const quizPage = document.getElementById("quizPage");

const startAssessment = document.getElementById("startAssessment");
const closePopup = document.getElementById("closePopup");

const userName = document.getElementById("userName");
const userEmail = document.getElementById("userEmail");

      if (!questionContainer) return;
      // Show popup only if user details are not already saved
const savedName = localStorage.getItem("assessmentName");
const savedEmail = localStorage.getItem("assessmentEmail");

if (!savedName || !savedEmail) {
    assessmentPopup.style.display = "flex";
} else {
    assessmentPopup.style.display = "none";
}

      function renderQuestion() {
        const activePart = quizData[`part${currentPart}`];
        const question = activePart[currentQuestion];

        let html = `<h3>${question.question}</h3>`;
        html += `<div id="questionError" class="quiz-error"></div>`;

        if (question.type === 'text') {
          html += `
      <textarea
        id="textAnswer"
        rows="6"
        placeholder="Write your answer here..."
        style="width:100%;padding:15px;border:1px solid #ddd;border-radius:8px;"
      >${selectedAnswers[currentQuestion] || ''}</textarea>
    `;
        } else {
          html += `
      <div class="options">
        ${question.options
          .map(
            (option, index) => `
              <label class="quiz-option">
                <input
                  type="radio"
                  name="quizOption"
                  value="${index}"
                  ${selectedAnswers[currentQuestion] === index ? "checked" : ""}
                >
                ${option.text}
              </label>
            `
          )
          .join("")}
      </div>
    `;
        }

        questionContainer.innerHTML = html;
        // Hide error when a radio option is selected
document.querySelectorAll('input[name="quizOption"]').forEach(input => {

    input.addEventListener("change", function () {

        const errorBox = document.getElementById("questionError");

        if (errorBox) {
            errorBox.innerText = "";
            errorBox.style.display = "none";
        }

    });

});

// Hide error when typing in textarea
const textarea = document.getElementById("textAnswer");

if (textarea) {

    textarea.addEventListener("input", function () {

        const errorBox = document.getElementById("questionError");

        if (errorBox) {
            errorBox.innerText = "";
            errorBox.style.display = "none";
        }

    });

}

        questionList.innerHTML = activePart
          .map(
            (item, index) => `

<div
 class="question-tab ${
                index === currentQuestion ? "active" : ""
            } ${
                index > currentQuestion ? "disabled" : ""
            }"
data-index="${index}">

Quiz Question ${index + 1}

</div>

`)
         .join("");
        document.querySelectorAll('.question-tab').forEach((tab) => {
          tab.addEventListener("click", function () {

    if (!validateCurrentQuestion()) {
        return;
    }

    currentQuestion = Number(this.dataset.index);
    renderQuestion();

});
        });

        prevBtn.disabled = currentQuestion === 0;

        nextBtn.innerText = currentQuestion === activePart.length - 1 ? `Finish Part ${currentPart}` : 'Next';
      }

      function validateCurrentQuestion() {

    const activePart = quizData[`part${currentPart}`];
    const question = activePart[currentQuestion];
    const errorBox = document.getElementById("questionError");

    errorBox.innerText = "";
    errorBox.style.display = "none";

    if (question.type === "text") {
        const answer = document.getElementById("textAnswer");

        if (!answer || answer.value.trim() === "") {
            errorBox.innerText = "Please enter your answer.";
            errorBox.style.display = "block";
             return false;
        }

        selectedAnswers[currentQuestion] = answer.value.trim();
    } else {

        const selected = document.querySelector(
            'input[name="quizOption"]:checked'
        );

        if (!selected) {
            errorBox.innerText = "Please select an option.";
            errorBox.style.display = "block";
            return false;
        }

        selectedAnswers[currentQuestion] = Number(selected.value);
    }

    return true;
}

      nextBtn.addEventListener("click", function () {

    if (!validateCurrentQuestion()) {
        return;
    }

    const activePart = quizData[`part${currentPart}`];

    if (currentQuestion < activePart.length - 1) {
        currentQuestion++;
        renderQuestion();
    } else {

        const score = selectedAnswers.reduce((sum, answer, index) => {

            if (typeof answer === "number") {
                return sum + activePart[index].options[answer].points;
            }

            return sum;

        }, 0);

        partScores[`part${currentPart}`] = score;

        if (currentPart === 4) {
            showFinalResult();
            return;
        }

        currentPart++;
        currentQuestion = 0;
        selectedAnswers = [];

        renderQuestion();
        updateStepUI();
    }
      });

      prevBtn.addEventListener('click', function () {
        if (currentQuestion > 0) {
          currentQuestion--;
          renderQuestion();
        }
      });
      closeScoreModal.addEventListener('click', function () {
        scoreModal.classList.remove('active');
      });

//       continueQuizBtn.addEventListener("click", function () {

//     window.location.href="/pages/assessment-result";

// });
      function updateStepUI() {
        const steps = document.querySelectorAll('.quiz-step');

        steps.forEach((step, index) => {
          step.classList.remove('active');
          step.classList.remove('completed');

          if (index + 1 < currentPart) {
            step.classList.add('completed');
          }

          if (index + 1 === currentPart) {
            step.classList.add('active');
          }
        });
      }
     function showFinalResult() {
      console.log("showFinalResult() called");
    const totalScore =
        (partScores.part1 || 0) +
        (partScores.part2 || 0) +
        (partScores.part3 || 0) +
        (partScores.part4 || 0);

      const resultPage =
totalScore <= 15
? "/pages/assessment-result-1"
: totalScore <= 30
? "/pages/assessment-result-2"
: totalScore <= 45
? "/pages/assessment-result-3"
: "/pages/assessment-result-4";

const resultTitle =
totalScore <= 15
? "The Embodied Seeker"
: totalScore <= 30
? "The Intellectual Achiever"
: totalScore <= 45
? "The Desperate Seeker"
: "The Guarded Skeptic";

const payload = {

    name: localStorage.getItem("assessmentName"),

    email: localStorage.getItem("assessmentEmail"),

    part1: partScores.part1,

    part2: partScores.part2,

    part3: partScores.part3,

    part4: partScores.part4,

    totalScore: totalScore,

    result: resultTitle,

    resultPage: resultPage

};  
fetch("https://hook.us2.make.com/9hi325lt98wejo3u8xmugst17cmu49gq", {

    method: "POST",

    headers: {

        "Content-Type":"application/json"

    },

    body: JSON.stringify(payload)

})
.then(res=>console.log("Sent to Make"))

.catch(err=>console.log(err));
    sessionStorage.setItem("assessmentScore", totalScore);

    scoreTitle.innerText = "Assessment Completed!";
    finalScore.innerText = totalScore;

    let message = "";

    if (totalScore <= 15) {

        message = "Excellent! You are already aligned.";

    } else if (totalScore <= 30) {

        message = "Good foundation. There are still patterns to release.";

    } else if (totalScore <= 45) {

        message = "Your assessment shows several emotional blocks ready for transformation.";

    } else {

        message = "Deep transformation is recommended.";

    }

    scoreMessage.innerText = message;

    continueQuizBtn.innerText = "View My Result";

    continueQuizBtn.onclick = function () {

        if (totalScore <= 15) {

            window.location.href = "/pages/assessment-result-1";

        }

        else if (totalScore <= 30) {

            window.location.href = "/pages/assessment-result-2";

        }

        else if (totalScore <= 45) {

            window.location.href = "/pages/assessment-result-3";

        }

        else {

            window.location.href = "/pages/assessment-result-4";

        }

    };

    scoreModal.classList.add("active");

}

// Start Assessment
startAssessment.addEventListener("click", function () {

    const name = userName.value.trim();
    const email = userEmail.value.trim();

    if (name === "") {
        alert("Please enter your name.");
        userName.focus();
        return;
    }

    if (email === "") {
        alert("Please enter your email.");
        userEmail.focus();
        return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
        alert("Please enter a valid email.");
        userEmail.focus();
        return;
    }

    // Save user details
   localStorage.setItem("assessmentName", name);
   localStorage.setItem("assessmentEmail", email);

    // Close popup
    assessmentPopup.style.display = "none";


});

// Close popup
closePopup.addEventListener("click", function () {
    window.location.href = "/pages/sacred-return";
});


      renderQuestion();
      updateStepUI();
    });